import {
  FaHeartbeat,
  FaStethoscope,
  FaClock,
  FaUserFriends,
  FaCertificate,
} from "react-icons/fa";
import { motion } from "framer-motion";
import Button from "../components/Button";

const containerVariants = {
  offscreen: {},
  onscreen: {
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const cardVariants = {
  offscreen: { y: 10, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", bounce: 0.2, duration: 0.8 },
  },
};

const ScreenTwo = () => {
  const features = [
    {
      icon: FaStethoscope,
      title: "Advanced Medical Care",
      text: "State-of-the-art treatments and specialized care from experienced gynecologists.",
    },
    {
      icon: FaCertificate,
      title: "Certified Excellence",
      text: "Internationally accredited facilities maintaining highest quality standards.",
    },
    {
      icon: FaClock,
      title: "12 Hrs Non-Stop Extensive Care",
      text: "9AM - 9PM throughout medical support and emergency services when needed.",
    },
    {
      icon: FaUserFriends,
      title: "Patient-First Approach",
      text: "Dedicated to providing compassionate, personalized healthcare solutions.",
    },
  ];

  return (
    <section
      id="about_us"
      className="py-20 px-6 md:px-10 relative overflow-x-hidden"
    >
      <motion.div
        className="relative max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 z-10"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: false, amount: 0.2 }}
        variants={containerVariants}
      >
        <motion.div
          variants={cardVariants}
          className="flex flex-col justify-center p-6 rounded-lg bg-white bg-opacity-80"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-pink-700 mb-4">
            About Us
          </h2>
          <p className="text-gray-700 text-lg mb-6 leading-relaxed">
            Delivering personalized PCOD care with advanced treatments and
            compassionate experts. We focus on long-term wellness and holistic
            solutions for women.
          </p>
          <Button
            label={"Learn More"}
            onClick={() => {
              const element = document.getElementById("services");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}
          />
        </motion.div>

        <motion.div
          className="grid grid-cols-1 gap-6 md:grid-cols-2 md:col-span-2"
          variants={containerVariants}
        >
          {features.map((item, index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              whileHover={{ scale: 1.05 }}
              className="p-6 rounded-lg shadow left-to-right group bg-white"
            >
              <item.icon className="text-pink-600 text-3xl mb-4" />
              <h3 className="font-bold text-lg text-gray-800 mb-2 group-hover:text-white">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm group-hover:text-white">
                {item.text}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default ScreenTwo;
